import { apiRequest } from "../lib/apiClient";
import type { NotificationLogOut } from "./types";

/** `GET /notifications/log` — OWNER-only, read-only. Every row is `status =
 * "LOGGED_NOT_SENT"` in this backend — no real email/SMS provider is wired up
 * (`app.services.notification_service.LogNotificationProvider` is the only implementation). */
export async function listNotificationLog(accessToken: string): Promise<NotificationLogOut[]> {
  return apiRequest<NotificationLogOut[]>("/notifications/log", { accessToken });
}
